import { z } from 'zod';
import type { AISchemaField, UISchemaField } from '../types/index';

export const statsAISchema: AISchemaField[] = [
  { name: 'headline', type: 'string', required: false, max: 80 },
  {
    name: 'stats',
    type: 'array<object>',
    required: true,
    fields: [
      { name: 'value', type: 'string', required: true, max: 16, hint: 'e.g. "98%", "$2.4B", "10K+"' },
      { name: 'label', type: 'string', required: true, max: 60 },
      { name: 'context', type: 'string', required: false, max: 100 },
    ],
  },
];

export const statsUISchema: UISchemaField[] = [
  { name: 'headline', type: 'text', label: 'Headline', max: 80 },
  { name: 'stats', type: 'stat_list', label: 'Stats', required: true },
];

export const statsZodSchema = z.object({
  headline: z.string().max(80).optional().nullable(),
  stats: z
    .array(
      z.object({
        value: z.string().max(16),
        label: z.string().max(60),
        context: z.string().max(100).optional().nullable(),
      }),
    )
    .min(1),
});

export type StatsContent = z.infer<typeof statsZodSchema>;

export const statsSample: StatsContent = {
  headline: 'Numbers that matter',
  stats: [
    { value: '98%', label: 'Customer satisfaction', context: 'across 12,000 reviews' },
    { value: '2.4×', label: 'Faster shipping', context: 'vs. industry baseline' },
    { value: '10K+', label: 'Active studios', context: 'in 40 countries' },
    { value: '$2B', label: 'Processed', context: 'in transactions' },
  ],
};
